import Picto from '../../atoms/Picto/Picto';
import breakpointStyles from '../../../styles/breakpoints.module.css';
import styles from './SelectionCount.module.css';

/**
 * Displays a selection count next to a tick icon.
 * Wide viewports show the full label; narrow viewports show only the icon and the count
 * while exposing the full label to assistive technologies.
 * @param {object} props
 * @param {number} props.count - Number of selected items
 * @param {string} props.label - Localized full label (e.g. "3 ligne(s) sélectionnée(s)")
 * @returns {JSX.Element}
 */
function SelectionCount({ count, label }) {
  return (
    <>
      <span className={`${styles.label} ${breakpointStyles['desktop-only']}`}>
        {label}
      </span>
      <span
        className={`${styles.compact} ${breakpointStyles['mobile-only']}`}
        aria-label={label}
      >
        <Picto icon="tick-square" className={styles.icon} />
        {count}
      </span>
    </>
  );
}

export default SelectionCount;
